import { baseUCGet } from '../base/baseUC';

const str = '';

export const paymentMethodModelGet = ({ 
    userId = '', 
}) => {
    return {
        description: str,
        isCash: false,
        showBanks: false,
        ...baseUCGet({ userId: userId, }),
    }
};